import React from 'react';
import { Container, Paper } from 'library';

import './LogoListBlock.scss';

const LogoListBlock = ({ theme = 'plain', title, logos = [] }) => {
  if (logos.length === 0) {
    return null;
  }

  return (
    <Paper theme={theme} className="LogoListBlock" pad={{ top: 4 }}>
      <Container row justify="center">
        <Container grid="10">
          {title && <h2>{title}</h2>}
          <div className="LogoListBlockWrapper">
            {logos.map((logo) => {
              return (
                <div className="LogoListBlockLogo" key={logo.sourceUrl}>
                  <img src={logo.sourceUrl} alt={logo.altText} />
                </div>
              );
            })}
          </div>
        </Container>
      </Container>
    </Paper>
  );
};

export default LogoListBlock;
